import React, { useState } from 'react';
import SchoolHeader from '@/components/SchoolHeader';
import CtaButton from '@/components/CtaButton';
import ErrorBanner from '@/components/ErrorBanner';

/**
 * Web·1 — identity challenge for cold email-link entry. The email is display
 * only (already verified — it received the link); the student's last name is
 * the shared secret.
 */
const VerifyScreen = ({ context, onSubmit, error, busy, notice }) => {
	const [lastName, setLastName] = useState('');

	const handleSubmit = (event) => {
		event.preventDefault();
		if (!busy && lastName.trim()) onSubmit(lastName);
	};

	return (
		<form onSubmit={handleSubmit} className="flex flex-col gap-[20px]">
			<SchoolHeader name={context?.school?.name} logo={context?.school?.logo} />

			<h1 className="text-[24px] font-extrabold text-[#16181d]">Confirm it’s you</h1>

			<p className="text-[14px] leading-[21px] text-[#7d7d7d]">
				You opened a secure link from {context?.school?.name ?? 'your school'}. Confirm your details to set up or manage
				Auto-Pay for your student — no account or password needed.
			</p>

			{notice ? <ErrorBanner>{notice}</ErrorBanner> : null}

			<div className="flex w-full flex-col gap-[7px]">
				<label className="text-[13px] font-semibold text-[#16181d]" htmlFor="pay-email">
					Email
				</label>
				<div className="flex h-[50px] w-full items-center gap-[8px] rounded-[12px] border-[1.5px] border-[#d5d7da] bg-[#f4f6f9] px-[16px]">
					<p id="pay-email" className="min-w-0 flex-1 truncate text-[15px] text-[#16181d]">
						{context?.payer_email_masked}
					</p>
					<span className="shrink-0 text-[13px]">🔒</span>
				</div>
				<p className="text-[12px] text-[#7d7d7d]">From your invoice — already verified.</p>
			</div>

			<div className="flex w-full flex-col gap-[7px]">
				<label className="text-[13px] font-semibold text-[#16181d]" htmlFor="pay-last-name">
					Student’s last name
				</label>
				<input
					id="pay-last-name"
					type="text"
					value={lastName}
					onChange={(event) => setLastName(event.target.value)}
					placeholder="Enter last name"
					autoComplete="off"
					className="h-[50px] w-full rounded-[12px] border-[1.5px] border-[#d5d7da] bg-white px-[16px] text-[15px] text-[#16181d] outline-none placeholder:text-[#7d7d7d] focus:border-[#676AF6]"
				/>
				{error ? <p className="text-[12px] text-[#b42318]">{error}</p> : null}
			</div>

			<div className="h-[4px]" />

			<CtaButton type="submit" disabled={busy || !lastName.trim()}>
				{busy ? 'Checking…' : 'Continue'}
			</CtaButton>
		</form>
	);
};

export default VerifyScreen;
